@if (state.activePageVersion; as version) {
  <div class="flex items-center justify-between gap-4">
    <div class="flex items-center gap-4">
      <dojo-topic-status [status]="version.page_status" [editable]="true"></dojo-topic-status>

      @if (version.page_status === 'published') {
        <dojo-button [size]="'s'" (click)="createDraft()" [fill]="'outline'">
          <dojo-icon icon="pencil" class="mr-1"></dojo-icon>
          <span>Create a draft version</span>
        </dojo-button>
      } @else {
        <dojo-button [size]="'s'" (click)="publish()" [fill]="'outline'">
          <dojo-icon icon="pencil" class="mr-1"></dojo-icon>
          <span>Publish</span>
        </dojo-button>
      }
    </div>
    <div class="flex items-center gap-1">
      <dojo-save-indicator [status]="state.formSavingStatus" />

      <dojo-icon-button
        matTooltip="Version history"
        icon="clock-rotate-left"
        (click)="openVersionBrowserDialog()"
      ></dojo-icon-button>

      @if (version.updated_at) {
        <div class="text-secondary whitespace-nowrap text-sm" [matTooltip]="version.updated_at | formatDate">
          Edited {{ version.updated_at | formatDateRelativeToNow }}
        </div>
      }
    </div>
  </div>

  <hr class="my-8" />

  <div class="flex gap-2">
    <div class="flex-1 overflow-hidden rounded-lg border border-neutral-200 bg-white shadow-sm dark:bg-black">
      <dojo-tiptap-editor-wrapper
        class="h-full"
        [placeholder]="'Start writing...'"
        [editorOptions]="editorOptions"
        [valueControl]="contentCtrl"
        [editable]="version.page_status === 'draft'"
        [scrollableParent]="scrollableContainer()"
        #tiptapEditor
      />
    </div>

    @if (tiptapEditor.editor(); as editorInstance) {
      <div class="table-contents sticky top-0 h-full px-4">
        <div class="mb-4 font-semibold">Table of Contents</div>
        <dojo-tiptap-table-of-contents
          [editor]="editorInstance"
          [tableOfContentData]="tiptapEditor.tableOfContentData()"
          [scrollableParent]="scrollableContainer()"
        />
      </div>
    }
  </div>
} @else {
  <dojo-loader />
}
